import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.BACKEND_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default instance



// WEBPACK FOOTER //
// ./src/services/api/api.js